import { FC } from "react";
import { TwoPanelTemplate } from "~/OnboardingApp/components";
import { LeftSection, RightSection } from "./components";

export const WelcomeNamePage: FC = () => {
  return (
    <TwoPanelTemplate left={<LeftSection />} right={<RightSection />} stack />
  );
};
